import { motion } from 'framer-motion';
import { Navigate, Route, Routes } from "react-router-dom";
import CapstoneWarRoom from "../components/MasterParcours/CapstoneWarRoom";
import LabActivityPage from "../components/MasterParcours/LabActivityPage2";
import RealTimeWall from "../components/MasterParcours/RealTimeWall";
import VideoCallPage from "../components/MasterParcours/VideoCallPage";
import Notifications from "../components/Notifications";
import ParcoursDetails from "../components/ParcoursDetails";
import ParcoursList from "../components/ParcoursList";
import { FieldConferenceView, TheoryConferenceView } from "../components/Simulations/ConferenceView";
import TrainingKitDetails from "../components/TrainingKitDetails";
import UserCard from "../components/UserCard";
import { useAuth } from "../contexts/AuthContext";
import AtelierCreator from "../pages/AtelierCreator";
import AteliersPage from '../pages/AteliersPage';
import CaseCreator from "../pages/CaseCreator";

import VisualizationPostures from '../components/Simulations/AtlasDesPostures.js';
import CasePage2 from '../components/Simulations/CasePage2.js';
import CommercialCreator from '../components/Simulations/CommercialCreator';
import Visualization3DView from '../components/Simulations/Visualization3DViewCopy';
import CentreAjustementIntro from '../pages/CentreAjustementIntro';
import CentreAjustement from '../pages/CentreAjustementV3';
import CGU from '../pages/Cgu.js';
import CommercialCase from '../pages/CommercialCase';
import CommercialPage from '../pages/CommercialPage';
import ContactPage from "../pages/ContactPage";
import DashboardLab from "../pages/DashboardLab2";
import EmailVerificationPage from '../pages/EmailVerificationPage';
import ForgotPassword from '../pages/ForgotPassword';
import GrandeEcole from "../pages/GrandeEcole";
import HomePage from "../pages/HomePageLab";
import LandingPageEducation from "../pages/LandingPageEducation";
import LandingPageEntreprise from "../pages/LandingPageEntreprise";
import LandingPagePartners from "../pages/LandingPagePartners";
import Login, { getRedirectPath } from "../pages/Login";
import Logout from "../pages/Logout";
import ManifestePage from "../pages/ManifestePage";
import ParcoursCreator from "../pages/ParcoursCreator1";
import ParcoursPage from "../pages/ParcoursPage";
import PartnersPage from "../pages/PartnersPage";
import PesacoreFamily from '../pages/PesacoreFamily';
import PesacoreIH from '../pages/PesacoreIH2';
import PesaExp from "../pages/PesaExp.js";
import PolitiqueConfidentialite from '../pages/PolitiqueConfidentialite';
//import FicheProfil from '../pages/FicheProfilTeam.jsx';
import GenericCase from '../pages/GenericCase.js';
import LandingPesacore from '../pages/LandingPesacore';
import MarketPlace from '../pages/MarketPlace';
import NDA from '../pages/NDA.js';
import RegisterBlocked from "../pages/RegisterBlocked";
import RegisterSuccessPage from '../pages/RegisterSuccessPage';
import ResetPassword from '../pages/ResetPassword';
import Subscribe from "../pages/Subscribe";
import TableauSystemique from '../pages/TableauSystemique2';
import JudoVerbalBattle from '../pages/ThaiMezra.js';
import UserProfile from "../pages/UserProfile";
import VerifyCertificate from '../pages/VerifyCertificate';
import WelcomeParticulier from '../pages/WelcomeParticulier';
//import Register from '../pages/Register.js';

const AppRoutes = () => {
  const { loading, user, ProtectedRoute, isAuthenticated } = useAuth();

  const publicPaths = [
    '/auth/login', '/auth/register', '/register-success',
    '/welcome/particulier', '/verify-email', '/forgot-password',
    '/reset-password', '/home-page', '/landing-pesacore', '/manifeste', '/contact',
    '/academia', '/entreprise', '/partners', '/partners-link', '/centre-intro',
  ];

  const isPublicRoute = publicPaths.some(p => 
    window.location.pathname.startsWith(p)
  );

  // Ne bloquer que si route protégée ET encore en chargement
  if (loading && !isPublicRoute) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#020617',
      }}>
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
          style={{
            width: 48, height: 48, borderRadius: '50%',
            border: '1px solid rgba(34,211,238,0.15)',
            borderTop: '1px solid #22d3ee',
          }}
        />
      </div>
    );
  }
  
  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/auth/register" element={<RegisterBlocked />} />
      <Route path="/auth/register-blocked" element={<RegisterBlocked />} />
      <Route path="/auth/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/landing-pesacore" element={<LandingPesacore />} /> 
      <Route path="/home-page" element={<HomePage />} />
      <Route path="/academia" element={<LandingPageEducation />} />
      <Route path="/entreprise" element={<LandingPageEntreprise />} />
      <Route path="/partners" element={<LandingPagePartners />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/verify-email" element={<EmailVerificationPage />} />
      <Route path="/register-success" element={<RegisterSuccessPage />} />
      <Route path="/manifeste" element={<ManifestePage />} />
      <Route path="/partners-link" element={<PartnersPage />} />
           
      
      <Route path="/welcome/particulier" element={<WelcomeParticulier />} />
      <Route path="/nda" element={<NDA />} />
      <Route path="/confidentialite" element={<PolitiqueConfidentialite />} />
      <Route path="/cgu" element={<CGU />} />
      
      
      <Route path="/commercial-sales/live/:token" element={<CommercialPage />} />
      
      {/* Routes Admin */}
      <Route path="/admin" element={<ProtectedRoute><GrandeEcole /></ProtectedRoute>} />
      <Route path="/admin/me" element={<ProtectedRoute><UserProfile /></ProtectedRoute>}  />
      <Route path="/admin/cases-creator" element={<ProtectedRoute><CaseCreator /></ProtectedRoute>} />
      <Route path="/admin/parcours-creator" element={<ProtectedRoute><ParcoursCreator /></ProtectedRoute>} />
      <Route path="/admin/ateliers-creator" element={<ProtectedRoute><AtelierCreator /></ProtectedRoute>} />
      <Route path="/admin/commercial-creator" element={<ProtectedRoute><CommercialCreator /></ProtectedRoute>} />  
      

      {/* Routes protégées */}      
      <Route path="/users/me" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
      <Route path="/pesa-exp" element={<ProtectedRoute><PesaExp /></ProtectedRoute>} />
      <Route path="/back-office" element={<ProtectedRoute><PesacoreIH /></ProtectedRoute>} />
      <Route path="/subscribe/:plan" element={<ProtectedRoute><Subscribe /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardLab /></ProtectedRoute>} />
      <Route path="/centre-ajustement" element={<ProtectedRoute><CentreAjustement /></ProtectedRoute>} />
      <Route path="/thai-mezra" element={<ProtectedRoute><JudoVerbalBattle /></ProtectedRoute>} />
      <Route path="/pesacore-family" element={<ProtectedRoute><PesacoreFamily /></ProtectedRoute>} />
      <Route path="/ateliers" element={<ProtectedRoute><AteliersPage /></ProtectedRoute>} />      
      <Route path="/parcours" element={<ProtectedRoute><ParcoursList /></ProtectedRoute>} />
      <Route path="/user-card" element={<ProtectedRoute><UserCard /></ProtectedRoute>} />
      <Route path="/parcours/:slug" element={<ProtectedRoute><ParcoursDetails /></ProtectedRoute>} />
      <Route path="/video-call" element={<ProtectedRoute><VideoCallPage /></ProtectedRoute>} />
      <Route path="/notifications/" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
      <Route path="/commercial-sales/" element={<ProtectedRoute><CommercialPage /></ProtectedRoute>} />
      <Route path="/centre-intro" element={<ProtectedRoute><CentreAjustementIntro /></ProtectedRoute>} />
      <Route path="/pesacore-market" element={<ProtectedRoute><MarketPlace /></ProtectedRoute>} />
      <Route
        path="/atlas-posture"
        element={
          <ProtectedRoute>
            <VisualizationPostures />
          </ProtectedRoute>
        }
      />

      <Route
        path="/tableau-systemique"
        element={<TableauSystemique /> }
      />
      
      <Route
        path="/simulateur/generic-case/:slug"
        element={
          <ProtectedRoute>
            <GenericCase />
          </ProtectedRoute>
        }
      />

      <Route
        path="/simulateur/commercial-case/:slug"
        element={
          <ProtectedRoute>
            <CommercialCase />
          </ProtectedRoute>
        }
      />

      <Route
        path="/simulateur/commercial-sales/:slug"
        element={
          <ProtectedRoute>
            <CommercialPage />
          </ProtectedRoute>
        }
      />
            
      <Route 
        path="/theory/generic/:slug" 
        element={
        <ProtectedRoute>
          <TheoryConferenceView />
        </ProtectedRoute>
        }
      />
      <Route 
        path="/viz3d/generic/:slug" 
        element={<ProtectedRoute><Visualization3DView /></ProtectedRoute>} 
      />

      <Route 
        path="/viz3d/:caseId" 
        element={<ProtectedRoute><Visualization3DView /></ProtectedRoute>} 
      />

      
      <Route
        path="/simulateur/case/:caseId"
        element={
          <ProtectedRoute>
            <CasePage2 />
          </ProtectedRoute>
        }
      />      
      <Route 
        path="/theory/:caseId" 
        element={
        <ProtectedRoute>
          <TheoryConferenceView />
        </ProtectedRoute>
        }
      />
      
      <Route 
        path="/field/:caseId" 
        element={
        <ProtectedRoute>
          <FieldConferenceView />
        </ProtectedRoute>
        }
      />
      <Route 
        path="/field/generic/:slug" 
        element={
        <ProtectedRoute>
          <FieldConferenceView />
        </ProtectedRoute>
        }
      />
      <Route 
        path="/investigation/:slug" 
        element={
        <ProtectedRoute>
          <ParcoursPage />
        </ProtectedRoute>
        }
      />
      <Route 
        path="/capstone/:capstoneId"
        element={
        <ProtectedRoute>
          <CapstoneWarRoom />
        </ProtectedRoute>
        }
      /> 
      <Route 
        path="/investigation/:slug/lab/:activityId"
        element={
        <ProtectedRoute>
          <LabActivityPage />
        </ProtectedRoute>
        }
      />
      <Route
        path="/training-kits/:kitId"
        element={
          <ProtectedRoute>
            <TrainingKitDetails/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/wall/:activityId"
        element={
          <ProtectedRoute>
            <RealTimeWall/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/verify/:certificateId"
        element={
          <ProtectedRoute>
            <VerifyCertificate/>
          </ProtectedRoute>
        } />
      
  
      <Route path="/auth/logout" element={<Logout />} />

      {/* Redirection par défaut */}
      <Route
        path="/"
        element={
          isAuthenticated && user
            ? <Navigate to={getRedirectPath(user.role)} replace />
            : <Navigate to="/home-page" replace />
        }
      />
    </Routes>
  );
};

export default AppRoutes;